/**
 * TOKCHAN Character Component
 *
 * Displays the character with body, eyes, and mouth layers.
 * Controlled by TokchanController for animations and expressions.
 */

import React, { useEffect, useRef } from 'react';
import './TokchanCharacter.css';

interface TokchanCharacterProps {
    bodyImage?: string;
    eyesImage?: string;
    mouthImage?: string;
}

export const TokchanCharacter: React.FC<TokchanCharacterProps> = ({
    bodyImage = '/assets/characters/body/body_1.png',
    eyesImage = '/assets/characters/eyes/eyes_1.png',
    mouthImage = '/assets/characters/mouth/mouth_1.png'
}) => {
    const characterRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Ensure character visibility
        const ensureVisibility = () => {
            if (characterRef.current) {
                characterRef.current.style.display = 'flex';
                characterRef.current.style.visibility = 'visible';
                characterRef.current.style.opacity = '1';
            }
        };

        ensureVisibility();

        // Set up periodic check for visibility
        const intervalId = setInterval(ensureVisibility, 5000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div
            id="tokchan-character"
            ref={characterRef}
            className="character-container"
        >
            <div id="character-core" className="character-core">
                <img
                    id="character-body"
                    src={bodyImage}
                    alt="TOKCHAN Body"
                    className="character-core-layer character-part"
                />
                <img
                    id="character-eyes"
                    src={eyesImage}
                    alt="TOKCHAN Eyes"
                    className="character-core-layer character-part eyes"
                />
                <img
                    id="character-mouth"
                    src={mouthImage}
                    alt="TOKCHAN Mouth"
                    className="character-core-layer character-part"
                />
            </div>
        </div>
    );
};

export default TokchanCharacter;
